import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='https://lyricstelugu.in'
      className='link footer__link'
    >
      Created By Thilak Kumar
    </a>
  </footer>
)

export default Footer